import React, { useState, useContext, useEffect } from "react";

import * as API from '../utils/APICalls'
import { AppContext } from "../context/AppProvider";
import { Box } from "@mui/material";



const DeletePersona = () => {
  const { updateAppData, assets, currentPersona, modalOpen, personas, userData,
    setCurrentAsset, newAsset, setNewAsset } = useContext(AppContext);

  const deletePersona = async () => {
    console.log('[Delete persona] (before):', personas)
    let ps = personas

    ps.splice(ps.findIndex(function (p) {
      return p?._id === currentPersona?._id;
    }), 1);

    console.log('[Delete persona] (after):', personas)
    await API.deletePersona(currentPersona)

    updateAppData({
      modalOpen: false,
      modalView: ''
    })
  }

  return (
    <Box style={{
      color: "#ffffff", height: '100%', padding: '0.5rem', width: '250px', minWidth: 'fit-content',
      margin: '2rem auto',
      boxShadow: '0px 0px 5px 2px rgba(0, 0,0, 0.5)',
      display: 'flex', flexDirection: 'column',
      border: '1px solid #000', borderRadius: '5px', textAlign: 'center', color: '#000000'
    }}>

      <h5> Would you like to delete:
        <h2 style={{
          color: '#00FF00', border: '2px solid #00ff00',
          borderRadius: '10px', padding: '0.25rem 0.55rem', width: 'fit-content',
          margin: '0.5rem auto'
        }}>
          {currentPersona?.personaTitle}
        </h2>
      </h5>
      <button className="redirect-button" style={{
        backgroundColor: "#FF3D9E", margin: '0.75rem auto'
      }}
        onClick={() => {
          deletePersona()

        }}
      >
        delete
      </button>
    </Box>

  )
}

export default DeletePersona